<template>
  <div class="RESPONSIVE-BACKGROUND">
    <div class="container p-y-3:t p-x-0:mo">
      <div class="RESPONSIVE-BORDER layout fd-column:mo bg-white">
        <div :class="{'d-none:mo': !isAboutRoot }" class="layout-item is-12 is-3:t">
          <p class="text-lg text-bold bd-b-gray30 p-l-2 p-t-2" selenium="about-us-heading">
            ABOUT US
          </p>
          <ul class="x-reset-list-styles">
            <li class="bd-b-gray30" selenium="about-us-link">
              <AboutMenuLink :link="{ name: 'about::us' }" exact>
                About us
              </AboutMenuLink>
            </li>
            <li class="bd-b-gray30" selenium="careers-link">
              <AboutMenuLink href="https://careers.homedepot.com/career-areas/technology-careers/" target="_blank" exact>
                Careers
              </AboutMenuLink>
            </li>
          </ul>

          <p class="text-lg text-bold bd-b-gray30 p-l-2 p-t-3" selenium="support-link">
            SUPPORT
          </p>
          <ul class="x-reset-list-styles">
            <li class="bd-b-gray30">
              <AboutMenuLink :link="{ name: 'about::faq' }" exact selenium="help-faq-link">
                Help/FAQs
              </AboutMenuLink>
            </li>
            <li>
              <AboutMenuLink
                  :link="{ name: 'about::legal' }"
                  class="bd-b-gray30"
                  selenium="legal-information-link">
                Legal Information
              </AboutMenuLink>
              <ul class="x-reset-list-styles text-md">
                <li class="bd-b-gray30">
                  <AboutMenuLink
                      :link="{ name: 'about::legal::tos::type' }"
                      exact
                      class="p-l-5"
                      selenium="terms-of-service-link">
                    Terms of Service
                  </AboutMenuLink>
                </li>
                <li class="bd-b-gray30">
                  <AboutMenuLink
                      :link="{ name: 'about::legal::privacy' }"
                      exact
                      class="p-l-5"
                      selenium="privacy-policy-link">
                    Privacy Policy
                  </AboutMenuLink>
                </li>
              </ul>
            </li>
            <li class="bd-b-gray30">
              <AboutMenuLink
                  :link="{ name: 'about::contact' }"
                  exact
                  selenium="contact-us-link">
                Contact Us
              </AboutMenuLink>
            </li>
          </ul>

        </div>

        <div class="RESPONSIVE-BORDER-LEFT layout-item is-12 is-9:t">
          <MenuNavigationButton :is-about-root="isAboutRoot"/>
          <div class="p-2 p-x-5:t">
            <router-view/>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MenuNavigationButton from './MenuNavigationButton';
import AboutMenuLink from './AboutMenuLink';

export default {
  name: 'company-info',
  metaInfo: {
    title: 'About',
  },
  components: {
    MenuNavigationButton,
    AboutMenuLink,
  },
  computed: {
    isAboutRoot () {
      return this.$route.matched.length === 1;
    },
  },
  mounted () {
    if (!this.$device.isMobile && this.isAboutRoot) {
      this.$router.replace({ name: 'about::us' });
    }
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .RESPONSIVE-BACKGROUND {
    @include responsive(background-color, none, $color-gray20);
    flex: 1 0 auto;
  }

  .RESPONSIVE-BORDER {
    @include responsive(border, none, solid 1px $color-gray50);
  }

  .RESPONSIVE-BORDER-LEFT {
    @include responsive(border-left, none, solid 1px $color-gray50);
  }
</style>
